import * as i0 from '@angular/core';
import { Component, Input, ContentChildren, NgModule } from '@angular/core';
import * as i1 from '@angular/common';
import { CommonModule } from '@angular/common';
import * as i2 from '@niceltd/cxone-components/overflow-tooltip';
import { OverflowTooltipModule } from '@niceltd/cxone-components/overflow-tooltip';
function TabComponent_div_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 1);
    i0.ɵɵprojection(1);
    i0.ɵɵelementEnd();
  }
}
const _c0 = ["*"];
function TabsComponent_div_2_span_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 9);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const tab_r1 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(tab_r1.title);
  }
}
function TabsComponent_div_2_span_3_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function TabsComponent_div_2_span_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtemplate(1, TabsComponent_div_2_span_3_ng_container_1_Template, 1, 0, "ng-container", 10);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const tab_r1 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", tab_r1.titleTemplate);
  }
}
const _c1 = (a0, a1) => ({
  "template": a0,
  "icon": a1
});
const _c2 = a0 => ({
  "minWidth": a0
});
const _c3 = a0 => ({
  "visible": a0
});
function TabsComponent_div_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r9 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 4);
    i0.ɵɵlistener("click", function TabsComponent_div_2_Template_div_click_0_listener() {
      const restoredCtx = i0.ɵɵrestoreView(_r9);
      const tab_r1 = restoredCtx.$implicit;
      const ctx_r8 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r8.setActive(tab_r1));
    });
    i0.ɵɵelementStart(1, "div", 5);
    i0.ɵɵtemplate(2, TabsComponent_div_2_span_2_Template, 2, 1, "span", 6)(3, TabsComponent_div_2_span_3_Template, 2, 1, "span", 7);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(4, "div", 8);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const tab_r1 = ctx.$implicit;
    const i_r2 = ctx.index;
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵclassProp("isActive", tab_r1.isActive);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(8, _c1, tab_r1.titleTemplate, tab_r1.iconOnly))("ngStyle", i0.ɵɵpureFunction1(11, _c2, tab_r1.minWidth + "px"));
    i0.ɵɵadvance();
    i0.ɵɵproperty("tooltipContent", tab_r1.title);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !tab_r1.titleTemplate);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", tab_r1.titleTemplate);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(13, _c3, !tab_r1.isActive && !(i_r2 + 1 < ctx_r0.tabs.length && ctx_r0.tabs.toArray()[i_r2 + 1].isActive)));
  }
}
const _c4 = ".upper-tabs[_ngcontent-%COMP%]{height:100%;box-shadow:0 2px 6px #1f324d33;background-color:#f7f9fa}.upper-tabs[_ngcontent-%COMP%]   .upper-tabs-header[_ngcontent-%COMP%]{display:inline-block}.upper-tabs[_ngcontent-%COMP%]   .upper-tabs-header[_ngcontent-%COMP%]   .upper-tab[_ngcontent-%COMP%]{height:45px;text-transform:uppercase;padding-top:6px;text-align:center;color:#3d6172;font-family:OpenSans;font-size:13px;background-color:#f7f9fa;display:inline-block;border-bottom:1px solid rgb(218,226,232);cursor:pointer}.upper-tabs[_ngcontent-%COMP%]   .upper-tabs-header[_ngcontent-%COMP%]   .upper-tab[_ngcontent-%COMP%]:hover{border-bottom:4px solid rgb(175,193,207);background-color:#f2f7fa}.upper-tabs[_ngcontent-%COMP%]   .upper-tabs-header[_ngcontent-%COMP%]   .upper-tab.isActive[_ngcontent-%COMP%]{border-bottom:4px solid rgb(0,124,190);font-family:OpenSans;font-weight:600;color:#2e2e2e;background-color:#fff;cursor:default}.upper-tabs[_ngcontent-%COMP%]   .upper-tabs-header[_ngcontent-%COMP%]   .upper-tab.isActive[_ngcontent-%COMP%]:hover{background-color:#f2f7fa}.upper-tabs[_ngcontent-%COMP%]   .upper-tabs-header[_ngcontent-%COMP%]   .upper-tab[_ngcontent-%COMP%]   .title-container[_ngcontent-%COMP%]{display:inline-block;padding:8px 23px 13px}.upper-tabs[_ngcontent-%COMP%]   .upper-tabs-header[_ngcontent-%COMP%]   .upper-tab[_ngcontent-%COMP%]   .separator[_ngcontent-%COMP%]{display:inline-block;vertical-align:top;width:1px;float:right;height:33px;border:0;background-color:transparent}.upper-tabs[_ngcontent-%COMP%]   .upper-tabs-header[_ngcontent-%COMP%]   .upper-tab[_ngcontent-%COMP%]   .separator.visible[_ngcontent-%COMP%]{background-color:#ced2d5}.upper-tabs[_ngcontent-%COMP%]   .upper-tabs-header[_ngcontent-%COMP%]   .upper-tab.template[_ngcontent-%COMP%]{vertical-align:bottom}.upper-tabs[_ngcontent-%COMP%]   .upper-tabs-header[_ngcontent-%COMP%]   .upper-tab.template[_ngcontent-%COMP%]   .title-container[_ngcontent-%COMP%]{padding:6px 23px 15px;height:34px;overflow:hidden}.upper-tabs[_ngcontent-%COMP%]   .upper-tabs-header[_ngcontent-%COMP%]   .upper-tab.template.icon[_ngcontent-%COMP%]   .title-container[_ngcontent-%COMP%]{padding:6px 15px 15px}.upper-tabs[_ngcontent-%COMP%]   .upper-tabs-content[_ngcontent-%COMP%]{height:calc(100% - 45px);margin-top:-1px;border-top:1px solid #DAE2E8}.remove-active-tab-margin[_nghost-%COMP%]   .active-tab[_ngcontent-%COMP%], .remove-active-tab-margin   [_nghost-%COMP%]   .active-tab[_ngcontent-%COMP%]{padding:0}.active-tab[_ngcontent-%COMP%]{height:100%;background-color:#fff;padding:20px}";
class TabComponent {
  constructor() {
    /**
     * in case of template - whether template is icon only (smaller width and padding)
     */
    this.iconOnly = false;
    this.isActive = false;
  }
  ngOnInit() {
    if (!this.minWidth) {
      this.minWidth = 140;
      if (this.titleTemplate && this.iconOnly) {
        this.minWidth = 50;
      }
    }
  }
  /** @nocollapse */
  static {
    this.ɵfac = function TabComponent_Factory(t) {
      return new (t || TabComponent)();
    };
  }
  /** @nocollapse */
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: TabComponent,
      selectors: [["cxone-tab"]],
      inputs: {
        title: "title",
        titleTemplate: "titleTemplate",
        iconOnly: "iconOnly",
        minWidth: "minWidth",
        isActive: "isActive"
      },
      ngContentSelectors: _c0,
      decls: 1,
      vars: 1,
      consts: [["class", "active-tab", 4, "ngIf"], [1, "active-tab"]],
      template: function TabComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵtemplate(0, TabComponent_div_0_Template, 2, 0, "div", 0);
        }
        if (rf & 2) {
          i0.ɵɵproperty("ngIf", ctx.isActive);
        }
      },
      dependencies: [i1.NgIf],
      styles: [".upper-tabs[_ngcontent-%COMP%]{height:100%;box-shadow:0 2px 6px #1f324d33;background-color:#f7f9fa}.upper-tabs[_ngcontent-%COMP%]   .upper-tabs-header[_ngcontent-%COMP%]{display:inline-block}.upper-tabs[_ngcontent-%COMP%]   .upper-tabs-header[_ngcontent-%COMP%]   .upper-tab[_ngcontent-%COMP%]{height:45px;text-transform:uppercase;padding-top:6px;text-align:center;color:#3d6172;font-family:OpenSans;font-size:13px;background-color:#f7f9fa;display:inline-block;border-bottom:1px solid rgb(218,226,232);cursor:pointer}.upper-tabs[_ngcontent-%COMP%]   .upper-tabs-header[_ngcontent-%COMP%]   .upper-tab[_ngcontent-%COMP%]:hover{border-bottom:4px solid rgb(175,193,207);background-color:#f2f7fa}.upper-tabs[_ngcontent-%COMP%]   .upper-tabs-header[_ngcontent-%COMP%]   .upper-tab.isActive[_ngcontent-%COMP%]{border-bottom:4px solid rgb(0,124,190);font-family:OpenSans;font-weight:600;color:#2e2e2e;background-color:#fff;cursor:default}.upper-tabs[_ngcontent-%COMP%]   .upper-tabs-header[_ngcontent-%COMP%]   .upper-tab.isActive[_ngcontent-%COMP%]:hover{background-color:#f2f7fa}.upper-tabs[_ngcontent-%COMP%]   .upper-tabs-header[_ngcontent-%COMP%]   .upper-tab[_ngcontent-%COMP%]   .title-container[_ngcontent-%COMP%]{display:inline-block;padding:8px 23px 13px}.upper-tabs[_ngcontent-%COMP%]   .upper-tabs-header[_ngcontent-%COMP%]   .upper-tab[_ngcontent-%COMP%]   .separator[_ngcontent-%COMP%]{display:inline-block;vertical-align:top;width:1px;float:right;height:33px;border:0;background-color:transparent}.upper-tabs[_ngcontent-%COMP%]   .upper-tabs-header[_ngcontent-%COMP%]   .upper-tab[_ngcontent-%COMP%]   .separator.visible[_ngcontent-%COMP%]{background-color:#ced2d5}.upper-tabs[_ngcontent-%COMP%]   .upper-tabs-header[_ngcontent-%COMP%]   .upper-tab.template[_ngcontent-%COMP%]{vertical-align:bottom}.upper-tabs[_ngcontent-%COMP%]   .upper-tabs-header[_ngcontent-%COMP%]   .upper-tab.template[_ngcontent-%COMP%]   .title-container[_ngcontent-%COMP%]{padding:6px 23px 15px;height:34px;overflow:hidden}.upper-tabs[_ngcontent-%COMP%]   .upper-tabs-header[_ngcontent-%COMP%]   .upper-tab.template.icon[_ngcontent-%COMP%]   .title-container[_ngcontent-%COMP%]{padding:6px 15px 15px}.upper-tabs[_ngcontent-%COMP%]   .upper-tabs-content[_ngcontent-%COMP%]{height:calc(100% - 45px);margin-top:-1px;border-top:1px solid #DAE2E8}.remove-active-tab-margin[_nghost-%COMP%]   .active-tab[_ngcontent-%COMP%], .remove-active-tab-margin   [_nghost-%COMP%]   .active-tab[_ngcontent-%COMP%]{padding:0}.active-tab[_ngcontent-%COMP%]{height:100%;background-color:#fff;padding:20px}"]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(TabComponent, [{
    type: Component,
    args: [{
      selector: 'cxone-tab',
      template: `
    <div *ngIf="isActive" class="active-tab">
      <ng-content></ng-content>
    </div>
  `,
      styles: [".upper-tabs{height:100%;box-shadow:0 2px 6px #1f324d33;background-color:#f7f9fa}.upper-tabs .upper-tabs-header{display:inline-block}.upper-tabs .upper-tabs-header .upper-tab{height:45px;text-transform:uppercase;padding-top:6px;text-align:center;color:#3d6172;font-family:OpenSans;font-size:13px;background-color:#f7f9fa;display:inline-block;border-bottom:1px solid rgb(218,226,232);cursor:pointer}.upper-tabs .upper-tabs-header .upper-tab:hover{border-bottom:4px solid rgb(175,193,207);background-color:#f2f7fa}.upper-tabs .upper-tabs-header .upper-tab.isActive{border-bottom:4px solid rgb(0,124,190);font-family:OpenSans;font-weight:600;color:#2e2e2e;background-color:#fff;cursor:default}.upper-tabs .upper-tabs-header .upper-tab.isActive:hover{background-color:#f2f7fa}.upper-tabs .upper-tabs-header .upper-tab .title-container{display:inline-block;padding:8px 23px 13px}.upper-tabs .upper-tabs-header .upper-tab .separator{display:inline-block;vertical-align:top;width:1px;float:right;height:33px;border:0;background-color:transparent}.upper-tabs .upper-tabs-header .upper-tab .separator.visible{background-color:#ced2d5}.upper-tabs .upper-tabs-header .upper-tab.template{vertical-align:bottom}.upper-tabs .upper-tabs-header .upper-tab.template .title-container{padding:6px 23px 15px;height:34px;overflow:hidden}.upper-tabs .upper-tabs-header .upper-tab.template.icon .title-container{padding:6px 15px 15px}.upper-tabs .upper-tabs-content{height:calc(100% - 45px);margin-top:-1px;border-top:1px solid #DAE2E8}:host-context(.remove-active-tab-margin) .active-tab{padding:0}.active-tab{height:100%;background-color:#fff;padding:20px}\n"]
    }]
  }], () => [], {
    title: [{
      type: Input
    }],
    titleTemplate: [{
      type: Input
    }],
    iconOnly: [{
      type: Input
    }],
    minWidth: [{
      type: Input
    }],
    isActive: [{
      type: Input
    }]
  });
})();
class TabsComponent {
  constructor() {
    this.activated = false;
  }
  ngAfterContentInit() {
    if (this.tabs.length > 0) {
      if (!this.tabs.find(tab => tab.isActive)) {
        this.setActive(this.tabs.first);
      }
      this.activated = true;
    }
  }
  setActive(tab) {
    this.tabs.forEach(t => t.isActive = false);
    tab.isActive = true;
  }
  /** @nocollapse */
  static {
    this.ɵfac = function TabsComponent_Factory(t) {
      return new (t || TabsComponent)();
    };
  }
  /** @nocollapse */
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: TabsComponent,
      selectors: [["cxone-tabs"]],
      contentQueries: function TabsComponent_ContentQueries(rf, ctx, dirIndex) {
        if (rf & 1) {
          i0.ɵɵcontentQuery(dirIndex, TabComponent, 4);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.tabs = _t);
        }
      },
      ngContentSelectors: _c0,
      decls: 5,
      vars: 1,
      consts: [[1, "upper-tabs"], [1, "upper-tabs-header"], ["class", "upper-tab", 3, "isActive", "ngClass", "ngStyle", "click", 4, "ngFor", "ngForOf"], [1, "upper-tabs-content"], [1, "upper-tab", 3, "ngClass", "ngStyle", "click"], ["cxoneOverflowTooltip", "", "placement", "auto top", 1, "title-container", 3, "tooltipContent"], ["class", "tab-title", 4, "ngIf"], [4, "ngIf"], [1, "separator", 3, "ngClass"], [1, "tab-title"], [4, "ngTemplateOutlet"]],
      template: function TabsComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵelementStart(0, "div", 0)(1, "div", 1);
          i0.ɵɵtemplate(2, TabsComponent_div_2_Template, 5, 15, "div", 2);
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(3, "div", 3);
          i0.ɵɵprojection(4);
          i0.ɵɵelementEnd()();
        }
        if (rf & 2) {
          i0.ɵɵadvance(2);
          i0.ɵɵproperty("ngForOf", ctx.tabs);
        }
      },
      dependencies: [i1.NgClass, i1.NgForOf, i1.NgIf, i1.NgTemplateOutlet, i1.NgStyle, i2.OverflowTooltipDirective],
      styles: [_c4]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(TabsComponent, [{
    type: Component,
    args: [{
      selector: 'cxone-tabs',
      template: "<div class=\"upper-tabs\">\n  <div class=\"upper-tabs-header\">\n    <div class=\"upper-tab\"\n         *ngFor=\"let tab of tabs; index as i\"\n         (click)=\"setActive(tab)\"\n         [class.isActive]=\"tab.isActive\"\n         [ngClass]=\"{'template': tab.titleTemplate, 'icon': tab.iconOnly}\"\n         [ngStyle]=\"{'minWidth': tab.minWidth + 'px'}\">\n      <div class=\"title-container\" cxoneOverflowTooltip [tooltipContent]=\"tab.title\" placement=\"auto top\" >\n        <span *ngIf=\"!tab.titleTemplate\" class=\"tab-title\" >{{tab.title}}</span>\n        <span *ngIf=\"tab.titleTemplate\"><ng-container *ngTemplateOutlet=\"tab.titleTemplate\"></ng-container></span>\n      </div>\n      <div class=\"separator\" [ngClass]=\"{ 'visible': !tab.isActive && !(i + 1 < tabs.length && tabs.toArray()[i+1].isActive)}\" ></div>\n    </div>\n  </div>\n  <div class=\"upper-tabs-content\">\n    <ng-content></ng-content>\n  </div>\n</div>",
      styles: [".upper-tabs{height:100%;box-shadow:0 2px 6px #1f324d33;background-color:#f7f9fa}.upper-tabs .upper-tabs-header{display:inline-block}.upper-tabs .upper-tabs-header .upper-tab{height:45px;text-transform:uppercase;padding-top:6px;text-align:center;color:#3d6172;font-family:OpenSans;font-size:13px;background-color:#f7f9fa;display:inline-block;border-bottom:1px solid rgb(218,226,232);cursor:pointer}.upper-tabs .upper-tabs-header .upper-tab:hover{border-bottom:4px solid rgb(175,193,207);background-color:#f2f7fa}.upper-tabs .upper-tabs-header .upper-tab.isActive{border-bottom:4px solid rgb(0,124,190);font-family:OpenSans;font-weight:600;color:#2e2e2e;background-color:#fff;cursor:default}.upper-tabs .upper-tabs-header .upper-tab.isActive:hover{background-color:#f2f7fa}.upper-tabs .upper-tabs-header .upper-tab .title-container{display:inline-block;padding:8px 23px 13px}.upper-tabs .upper-tabs-header .upper-tab .separator{display:inline-block;vertical-align:top;width:1px;float:right;height:33px;border:0;background-color:transparent}.upper-tabs .upper-tabs-header .upper-tab .separator.visible{background-color:#ced2d5}.upper-tabs .upper-tabs-header .upper-tab.template{vertical-align:bottom}.upper-tabs .upper-tabs-header .upper-tab.template .title-container{padding:6px 23px 15px;height:34px;overflow:hidden}.upper-tabs .upper-tabs-header .upper-tab.template.icon .title-container{padding:6px 15px 15px}.upper-tabs .upper-tabs-content{height:calc(100% - 45px);margin-top:-1px;border-top:1px solid #DAE2E8}:host-context(.remove-active-tab-margin) .active-tab{padding:0}.active-tab{height:100%;background-color:#fff;padding:20px}\n"]
    }]
  }], () => [], {
    tabs: [{
      type: ContentChildren,
      args: [TabComponent]
    }]
  });
})();
class TabsModule {
  /** @nocollapse */static {
    this.ɵfac = function TabsModule_Factory(t) {
      return new (t || TabsModule)();
    };
  }
  /** @nocollapse */
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: TabsModule
    });
  }
  /** @nocollapse */
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [CommonModule, OverflowTooltipModule]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(TabsModule, [{
    type: NgModule,
    args: [{
      declarations: [TabsComponent, TabComponent],
      imports: [CommonModule, OverflowTooltipModule],
      exports: [TabsComponent, TabComponent]
    }]
  }], null, null);
})();

/**
 * Generated bundle index. Do not edit.
 */

export { TabComponent, TabsComponent, TabsModule };
